/**
 * LOCKED — the per-surface density statement, in the product's own voice
 * (minimalist ruling: the page states what it withholds and what stands in
 * its place). Data-bearing: muted-foreground ink, never faint.
 */
export function DensityNote({ children }: { children: React.ReactNode }) {
  return (
    <p className="mt-6 border-t border-border pt-3 text-xs italic text-muted-foreground">
      {children}
    </p>
  )
}
